import styled, { keyframes } from 'styled-components';
import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import { FaTimes, FaUser, FaHome, FaChartLine, FaChartPie, FaCreditCard, FaEye, FaEyeSlash, FaTrashAlt, FaLink } from 'react-icons/fa';
import { HiOutlineCurrencyDollar } from 'react-icons/hi';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { BiMessageDetail, BiMessageX } from "react-icons/bi";
import { MdRefresh } from "react-icons/md";
import { TbLinkPlus } from "react-icons/tb";
import { FaTableList } from "react-icons/fa6";

export const AccountContainer = styled.div`
  min-height: 1500px;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 0;
  overflow: scroll;
  align-items: center;
  justify-content: cneter;
  background: linear-gradient(
    108deg,
    rgba(204, 143, 45, 1) 0%,
    rgb(0 0 0) 100%
  );
`;

export const AccountWrapper = styled.div`
  color: #000;
  display: flex;
  overflow: hidden;
  min-width: 95%;
  max-width: 99%;
  margin-top: 80px;
  min-height: 80%;

  @media screen and (min-width: 490px){
    min-width: 62%;
    max-width: 100%;
    min-height: 800px;
  }
`;

export const SidebarContainer = styled.aside`
  width: 6%;
  border-radius: 12px 0px 0px 12px;
  height: auto;
  background: grey;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  left: 0;
  transition: 0.3s ease-in-out;

  @media screen and (max-width: 490px) {
    min-width: 12%;
  }
`;


export const SidebarWrapper = styled.div`
  color: #fff;
  align-items: center;
  justify-content: space-around;
`;

export const Icon = styled.div`
  text-align: center;
  padding: 28px;

  @media screen and (max-width: 480px) {
  }
`;


export const IconNav = styled(LinkR)`
  margin-left: 32px;
  margin-top: 32px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 32px;

  @media screen and (min-width: 490px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;


const loadingAnimation = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;


export const CloseIcon = styled(FaTimes)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#cc8f2d' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const LineIcon = styled(FaChartLine)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#cc8f2d' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const CryptoIcon = styled(HiOutlineCurrencyDollar)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#cc8f2d' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;


export const PieIcon = styled(FaChartPie)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#cc8f2d' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;


export const CardIcon = styled(FaCreditCard)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#cc8f2d' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;


export const UserIcon = styled(FaUser)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#cc8f2d' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;


export const HomeIcon = styled(FaHome)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#cc8f2d' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;


export const Card = styled.div`
  background-color: #fff;
  border-radius: 0px 12px 12px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  width: 100%;
  min-height: 80%;
`;

export const AccountFormWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 80%;

  @media screen and (max-width: 490px) {
    margin-top: 100px;
    height: 80%;
    margin-bottom: 40px;
  }
`;

export const LoadingHeaderBar = styled.div`
  width: 60%;
  height: 12px; /* Adjust height as needed */
  background: linear-gradient(to right, #e0e0e0 8%, #f0f0f0 18%, #e0e0e0 33%);
  background-size: 200px 100%;
  animation: ${loadingAnimation} 1.5s infinite;
  padding: 12px;
  margin: 12px;
`;


export const LoadingDescriptionBar = styled.div`
  width: 70%;
  height: 12px; /* Adjust height as needed */
  background: linear-gradient(to right, #e0e0e0 8%, #f0f0f0 18%, #e0e0e0 33%);
  background-size: 200px 100%;
  animation: ${loadingAnimation} 1.5s infinite;
  padding: 12px;
  margin: 12px;
`;


export const LoadingButton = styled.div`
  width: 42px;
  height: 20px; /* Adjust height as needed */
  background: linear-gradient(to right, #e0e0e0 8%, #f0f0f0 18%, #e0e0e0 33%);
  background-size: 200px 100%;
  animation: ${loadingAnimation} 1.5s infinite;
  padding: 12px;
  margin: 12px;
`;

export const AccountDetailsSection = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
  margin: 20px auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const TransactionTable = styled.table`
 width: 100%;
 border-collapse: collapse;
 margin: 20px 0;

   @media screen and (min-width: 490px) {
    max-width: 90%;
  }
`;

export const TransactionRow = styled.div`
  display: inline-flex;
  background: white;
  flex-direction: row;
  margin-top: 20px;
  padding: 20px;
  grid-gap: 20px;
  justify-content: center;
  margin-right: 2px;
  margin-left: 2px;
  max-width: 95%;
  align-items: center;

  @media screen and (min-width: 490px){
    justify-content: space-around;
    min-width: 900px;
    grid-template-columns: 400px 800px;
    padding: 20px;
  }
`;



export const ThumbnailImage = styled.img`
  width: 600px;
  height: auto;
  // object-fit: cover; Uncomment if needed
  background: #232a34;
  justify-content: center;
  border: 12px solid #cc8f2d; /* Base border color */
  // border-image-source: url('path-to-your-ornate-border-image.png'); /* Path to ornate border image */
  // border-image-slice: 30 fill; /* Adjust slice to fit your image */
  // border-image-width: 10px; /* Width of the border image */
  // border-image-outset: 0; /* Optional: adjust if needed */
  // border-image-repeat: stretch; /* Adjust if needed */

  @media screen and (max-width: 490px) {
    justify-content: space-around;
    width: 225px;
  }
`;


export const TransactionTableButton = styled.button`
  color: ${({ status }) => (status === 'succeeded' ? '#fff' : 'black')};
  border: none;
  border-radius: 50px;
  background: ${({ status }) => (status === 'succeeded' ? 'green' : 'cc8f2d')};
  font-size: 16px;
  padding: 10px 22px;
  border: 2px solid white;
  // cursor: ${({ status }) => (status === 'succeeded' ? 'mouse' : 'pointer')};
  &:focus {
    outline: none;
    border: 2px solid gold;
  }

 @media screen and (max-width: 490px){
    font-size: 12px;
    padding: 6px;
  }
`;


export const LinkButton = styled(LinkR)`
  border-radius: 50px;
  background: #cc8f2d;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin-top: 24px;
  min-width: 100px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #cc8f2d;
  }

   @media screen and (min-width: 490px){
    min-width: 200px;
  }
`;

export const FormH2 = styled.div`
  color: #cc8f2d;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 12px;
  margin-bottom: 12px;

 @media screen and (max-width: 490px){
    text-align: center;
  }

`;

export const FormText = styled.p`
  width: 90%;
  font-size: 12px;
  line-height: 12px;
  color: black;
  margin-bottom: 6px;
`;


export const SectionTitle = styled.h2`
  margin-bottom: 20px;
  color: gray;
  font-size: 18px;
  font-weight: 400;
`;

export const TransactionList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

export const TransactionItem = styled.li`
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const TransactionTableHeader = styled.thead`

`;

export const TransactionTableRow = styled.tr`

`;

export const TransactionTableBody = styled.tbody`
`;

export const TransactionHeader = styled.th`
 border: none;
 padding: 8px;
 background-color: #fff;
 text-align: left;
 color: grey;
 @media screen and (max-width: 490px){
    font-size: 10px;
    padding: 1px;
  }
`;



export const TransactionData = styled.td`
 border-top: 1px solid #ddd;
 padding: 8px;
 color: black;

 @media screen and (max-width: 490px){
    font-size: ${({ variableText }) => (variableText ? '10px' : '12px')};
    padding: 6px;

  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #cc8f2d;
  border-radius: 50%;
  margin-top: 28px;
  margin-bottom: 12px;
  width: 32px;
  height: 32px;
  animation: ${spin} 1s linear infinite;
`

export const ServicesWrapper = styled.div`
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 16px;
  padding: 0 50px;
  margin-bottom: 16px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
`;

export const AnalysisWrapper = styled.div`
  max-width: 100%;
  margin: 20px 10px;
  display: grid;
  grid-template-columns: 1fr;
  flex-direction: column;
  align-items: center;
  padding: 0 50px;
  justify-content: center;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ServicesCard = styled.div`
  background: #cc8f2d;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  margin-bottom: 16px;

  &:hover {
    transform: scale(1.05);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const ServicesIcon = styled.img`
  height: 300px;
  width: 300px;
  margin-bottom: 10px;
`;

export const ServicesH1 = styled.h1`
  font-size: 2.5rem;
  color: black;
  margin-top:10px;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const ServicesH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 10px;
`;

export const ServicesP = styled.p`
  font-size: 1rem;
  text-align: center;
`;
export const FormContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 480px) {
    padding: 10px;
  }
`;

export const Form = styled.form`
  background: linear-gradient(
    112deg,
   #000 0%,
    #cc8f2d 100%
  );
  max-width: 95%;
  height: auto;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  margin: 100px auto;
  padding: 80px 32px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  justify-content: center;
  align-items: center;
  @media screen and ((max-width: 490px) ) {
    padding: 32px 32px;
  }
`;

export const FormOut = styled.form`
  background: #101522;
  height: auto;
  width: 100%;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 80px 32px;
  justify-content: center;
  align-items: center;
`;

export const HeaderContainer = styled.div`
  min-width 75%;
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid #cc8f2d;
  margin-bottom: 12px;
  justify-content: space-between;
  align-items: center;
  @media screen and ((max-width: 490px) ) {
    min-width: 100%;
    flex-direction: column;
  }
`

export const FormH1 = styled.h1`
  color: #cc8f2d;
  font-size: 20px;
  font-weight: bold;
  text-align: start;
  margin-left: 12px;
`;

export const RowContainer = styled.div`
  // background: linear-gradient(
  //   112deg,
  // #cc8f2d 0%,
  //   #fff 100%
  // );

  background:rgb(35, 36, 40); //rgb(155, 155, 155);
  // border-bottom: 2px solid #cc8f2d;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 75%;
  margin-bottom: 12px;

  @media screen and ((max-width: 490px) ) {
    width: 84vw;
  }
`;

export const AccountRow = styled.div`
  // background: linear-gradient(
  //   112deg,
  // #cc8f2d 0%,
  //   #fff 100%
  // );
  display: flex;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  width: 100%;

  @media screen and ((max-width: 490px) ) {
    padding: 32px 32px;
  }
`;

export const AccountRow2 = styled.div`
  // background: linear-gradient(
  //   112deg,
  // #cc8f2d 0%,
  //   #fff 100%
  // );
  display: flex;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 42px;
  width: 100%;

  @media screen and ((max-width: 490px) ) {
    padding: 32px 32px;
  }
`;

export const StyledIconContainer = styled.div`
 display:flex;
 flex-direction: row;
 justify-content: center;
 align-items: center;
 magin-bottom: 0px;
 max-height:36px;
`;

export const StyledIconButton = styled(FaEye)`
 margin: 14px;
 color: #fff;


  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const StyledIconSlashButton = styled(FaEyeSlash)`
 margin: 14px;
 color: #fff;


  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;


export const StyledIconPie = styled(FaChartPie)`
 margin: 14px;
 color: ${({ selected }) => (selected ? '#cc8f2d' : '#fff')};


  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;


export const StyledIconTable = styled(FaTableList)`
 margin: 14px;
 color:${({ selected }) => (selected ? '#cc8f2d' : '#fff')};


  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const FormH3 = styled.div`
  color: white;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 12px;

 @media screen and (max-width: 490px){
    text-align: left;
    margin-left: 6px;
    margin-top: 6px;
    margin-bottom: 6px;
  }

`;

export const FormSelectDropdownContainer = styled.div`
  align-items: center;
  z-index: 98;
  margin: 12px;
`;


export const FormLabel = styled.label`
  margin-bottom: 8px;
  margin-right: 8px;
  font-size: 16px;
  color: #cc8f2d;
  font-weight: bold;
`;


export const FormSelect = styled.select`
  color: black;
  background: #cc8f2d;
  font-weight: bold;
  border: none;
  padding: 8px;
  border-radius: 8px;
`;



export const FormInputDropdownContainer = styled.div`
  align-items: center;
  z-index: 98;
`;

export const FormInput = styled.input`
  padding: 16px 16px;
  margin: 0px;
  border-radius: 4px;
  border-color: #101522;
  max-height: 32px;
  width: 200px;

    &:focus {
    outline: none;
    border: 2px solid #cc8f2d;
  }
`;

export const FormButton = styled.button`
  background: ${({ showMods }) => (showMods ? 'white' : '#cc8f2d')};
  border: none;
  border-radius: 4px;
  color: ${({ showMods }) => (showMods ? '#cc8f2d' : 'black')};;
  font-size: 20px;
  margin: 20px;
  cursor: pointer;
  height: 30px;
  width: 200px;


 @media screen and (max-width: 490px){
    font-size: 18px;
    max-width: 150px;
  }
`;

export const GraphComponentContainer = styled.div`
 width: auto;
 height: '1000px';
 display: 'flex';
 flexDirection: 'column',
 overflow: 'scroll';
 margin-top: 20px;
`;

export const ButtonHeader = styled.div`
  display: flex;
  height: inheret;
  width: inheret;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const RemoveWLButton = styled.button`
  background: #fff;
  border-radius: 4px;
  color: black;
  border-color:  #cc8f2d;
  padding: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 4px;

  &:hover {
    background: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;

export const CloseComponentButton = styled(FaTimes)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  &:hover {
    color: #cc8f2d;
    transition: 0.2s ease-in-out;
  }
`;
export const DropdownContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 100;

`

export const JobsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`


export const JobsStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 600px;
  
 @media screen and (max-width: 490px){
   width: 320px;
   max-width: 90%;

  }
`

export const RowInfoStack = styled.div`
  display:flex;
  flex-direction: column;
  min-width: 100px;
  justify-content: center;
  text-align: center;
`;

export const JSInfoH1 = styled.div`
  color: #cc8f2d;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: 12px;
  margin-bottom: 4px;

 @media screen and (max-width: 490px){
    text-align: center;
    font-size: 10px;
  }

`;
export const JSInfoText = styled.div`
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1px;
  text-transform: uppercase;

 @media screen and (max-width: 490px){
    text-align: center;
    font-size: 10px;
  }

`;

export const WatchlistRow = styled.button`
  background: #cc8f2d;
  border: none;
  border-radius: 4px;
  color: black;
  font-size: 20px;
  cursor: pointer;
  margin: 1px 0px;
  height: 30px;
  width: 200px;
  z-index: 100;
`
export const AccountPieWrap = styled.div`
  position: absolute;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

export const InputItemContainer = styled.div`
  color: white;
  margin-left: 200px;
  justify-content: right;
  display: flex;
  flex-direction: row;
`

export const CheckboxContainer = styled.div`
  color: white;
  justify-content: right;
  display: flex;
  flex-direction: row;
`;

export const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  // width: 20px;
  // height: 20px;
  border: 2px solid #cc8f2d;
  margin-right: 12px;
  position: relative;
  accent-color: #cc8f2d;
  transition: background-color 0.3s ease;
  // background-color: ${({ checked }) => (checked ? 'white' : 'cc8f2d')};
`;

export const RegularText = styled.div`
  margin-right: 20px;
  font-size: 16px;
`
export const ToolTipContainer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  justify-content: center;
  background: black;
  border-radius: 4px;
  max-width: 200px;
  padding: 10px;
  z-index: 98;

 @media screen and (max-width: 490px){
    right: ${({ tuneRight }) => tuneRight ? '20px' : '3px'};
    top: ${({ tuneTop, tuneTopVal, top }) => tuneTop ? tuneTopVal : top};
    max-width:${({ tuneRight }) => tuneRight ? '90px' : '70px'};
    font-size: 10px;
  }
`;


export const ToolTipTopLine = styled.div`
  justify-content: center;
  text-align: left;
  // letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #cc8f2d;
  margin-bottom: 10px;

 @media screen and (max-width: 490px){
    right: 9px;
    font-size: 10px;
  }
`;

export const ToolTipP = styled.div`
  justify-content: center;
  color: #ffffff;
  border-bottom: 2px solid white;
  text-align: left;

 @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;

export const ToolTipFooter = styled.div`
  color: #cc8f2d;
  width: 100%;
  display: flex;
  justify-content: space-between;

 @media screen and (max-width: 490px){
  right: 10px;
  font-size: 10px;
 }
`;

export const ToolTipControl = styled.button`
  color: #cc8f2d;
  text-align: left;
  background: none;
  border: none;
  @media screen and (max-width: 490px){
    right: 10px;
    font-size: 10px;
  }
`;

export const ToolTipPointer = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  right: ${({ right }) => right};
  height: 0;
  width: 0;
  border-left: 12px solid black;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  z-index: 98;

 @media screen and (max-width: 490px){
    max-width: 80px;
    right: ${({ tuneRight, tuneRightVal }) => tuneRight ? '102px' : '65px'};
    top: ${({ tuneTop, tuneTopVal, top }) => tuneTop ? tuneTopVal : top};
    font-size: 10px;
    border-left: none;
    border-right: 12px solid black;
    z-index: 97;
  }
`;

export const ToggleButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;

   @media screen and (max-width: 490px){
    flex-direction: column;
    justify-contend: center;
    align-items: center;
  }
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ToggleSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 140px;
  height: 26px;
  margin-right: 4px;
   @media screen and (max-width: 490px){
    margin-top: 4px;
    margin-bottom: 4px;
    margin-right: 0px;
  }
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + div {
    background-color: #cc8f2d;
  }

  &:checked + div > .icon-wrapper {
    transform: translateX(105px);
  }
`;

export const Slider = styled.div`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: black;
  border-radius: 34px;
  transition: background-color 0.4s;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 4px;
  height: 26px;
  width: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: transform 0.4s;
`;

export const TipsOn = styled(BiMessageDetail)`
`;

export const TipsOff = styled(BiMessageX)`
`;

export const TipBox = styled.div`
  justify-content: center;
  color: ${({ demo }) => demo ? 'black' : '#cc8f2d'};
  font-size: 18px;
  Text-align: center;
  margin-top: 3px;
`;


export const RemoveAccountButton = styled(FaTrashAlt)`
 margin: 14px;
 color: #cc8f2d;

  height: 13px;
  &:hover {
    color: #fff;
    transition: 0.2s ease-in-out;
  }
`;

export const HeaderClose = styled(FaTimes)`
 margin: 14px;
 color: #cc8f2d;


  &:hover {
    color: #fff;
    transition: 0.2s ease-in-out;
  }
`;

export const StyledIconLink = styled(TbLinkPlus)`
 margin: 14px;
 color: #cc8f2d;


  &:hover {
    color: #fff;
    transition: 0.2s ease-in-out;
  }
`;

export const StyledIconRefresh = styled(MdRefresh)`
 margin: 14px;
 color: #cc8f2d;


  &:hover {
    color: #fff;
    transition: 0.2s ease-in-out;
  }
`;
